export const formatDate = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  if (isNaN(date)) return dateString;
  return new Intl.DateTimeFormat("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
  })
    .format(date)
    .replace(/(\d+)(?:st|nd|rd|th)/, "$1")
    .replace(/(\d+)/, (match) => {
      const num = parseInt(match);
      const suffix =
        num % 10 === 1 && num !== 11
          ? "st"
          : num % 10 === 2 && num !== 12
          ? "nd"
          : num % 10 === 3 && num !== 13
          ? "rd"
          : "th";
      return `${match}${suffix}`;
    });
};